import { DashboardResponse, OnTimeDelivery } from '../types/dashboard.types';
import axiosInstance from '../Components/Request';

export type OtdRange = 'month' | 'last30' | 'all';

export const dashboardService = {
  /**
   * Fetches dashboard data from the API
   * Cookies are sent automatically via withCredentials
   * @returns Promise with dashboard data
   */
  getDashboard: async (): Promise<DashboardResponse> => {
    try {
      const response = await axiosInstance.get('/dashboard');
      console.log('✅ Dashboard data received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Dashboard fetch error:', error);
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Error desconocido al cargar el dashboard');
    }
  },

  /**
   * Fetches the OTD rate filtered by a date range.
   * @param range 'month' | 'last30' | 'all' (backend defaults to month)
   */
  getOtd: async (range: OtdRange): Promise<OnTimeDelivery> => {
    const response = await axiosInstance.get('/dashboard/otd', { params: { range } });
    return response.data;
  },
};
